import { render, staticRenderFns } from "./SalesforceSync.vue?vue&type=template&id=2836a1f4&"
import script from "./SalesforceSync.vue?vue&type=script&lang=js&"
export * from "./SalesforceSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports